import { api } from './client';

export interface DiskEntry {
  name: string;
  path: string;
  size_bytes: number;
}

export interface DiskBreakdown {
  path: string;
  total_bytes: number;
  scanned_at: string;
  entries: DiskEntry[];
}

export const fetchBreakdown = (path: string, bust = false): Promise<DiskBreakdown> =>
  api.get<DiskBreakdown>('/disk/breakdown', { params: { path, ...(bust ? { bust: '1' } : {}) } })
    .then((r) => r.data);
